import { render, staticRenderFns } from "./MarketingView.vue?vue&type=template&id=b201550c&scoped=true"
import script from "./MarketingView.vue?vue&type=script&lang=js"
export * from "./MarketingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b201550c",
  null
  
)

export default component.exports